import React from 'react';

import {createRoot} from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.scss';
import App from './App';

//redux stuff
import {Provider} from 'react-redux';
import {store, persistor} from './store/store';
import {PersistGate} from 'redux-persist/integration/react';

//stripe stuff
import {Elements} from '@stripe/react-stripe-js';
import { stripePromise } from './utils/stripe/stripe.utils';

import reportWebVitals from './reportWebVitals';


createRoot(document.getElementById('root')).render(
  <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Elements stripe={stripePromise}>
          <App/>
        </Elements>
      </BrowserRouter>
    </PersistGate>
  </Provider>
</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
